import { MODE_FIELD } from '../../components/KendoDataGrid/constants';

export const EMPTY_VALUE_PLACEHOLDER = '-';
export const FIELDS_TO_OMIT = [MODE_FIELD];
